export default __webpack_public_path__ + "static/media/new_wallet@2x.f8e41a63.png";